import React, { FC } from 'react';
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Dividends } from '@app/components/Dividends';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const DivdendsModal: FC<Props> = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      isCentered
      motionPreset="slideInBottom"
      size="xs"
    >
      <ModalOverlay />
      <ModalContent sx={{ maxWidth: ['100vw', '586px'], padding: '0px' }}>
        <Dividends onClose={onClose} />
      </ModalContent>
    </Modal>
  );
};
